/* ===== Horarios de colecta (store_cutoffs) =====
 * weekday: 0=domingo, 1=lunes, ... 6=sábado (igual que backend / EXTRACT(DOW)).
 * window_seq: 1=primera pasada, 2=segunda pasada, etc.
 * Sin fila para un día = ese día no se colecta.
 */

export type StoreCutoff = {
  id?: number;
  weekday: number;
  window_seq: number;
  cutoff_time: string;
  active?: boolean;
};

export type StoreCutoffPayload = {
  weekday: number;
  window_seq: number;
  cutoff_time: string;
  active: boolean;
};

/** Una pasada dentro de un día, en estado de edición local (no viaja al backend tal cual). */
export type DayPass = {
  localId: string;
  time: string;
};

/** Estado de edición de un día completo de la semana. */
export type DaySchedule = {
  weekday: number;
  enabled: boolean;
  passes: DayPass[];
};

/** La semana completa, siempre con 7 entradas (una por weekday). */
export type WeeklySchedule = DaySchedule[];

/** Orden de despliegue en la UI: lunes a domingo. */
export const WEEKDAY_DISPLAY_ORDER = [1, 2, 3, 4, 5, 6, 0] as const;

export const WEEKDAY_SHORT: Record<number, string> = {
  0: "DOM",
  1: "LUN",
  2: "MAR",
  3: "MIÉ",
  4: "JUE",
  5: "VIE",
  6: "SÁB",
};

export const PASS_ORDINAL: string[] = [
  "Primera pasada",
  "Segunda pasada",
  "Tercera pasada",
  "Cuarta pasada",
  "Quinta pasada",
];

export const passOrdinalLabel = (index: number) =>
  PASS_ORDINAL[index] || `Pasada ${index + 1}`;

/* ===== Agrupación Lun-Vie / Sáb / Dom =====
 * Regla de negocio: lunes a viernes SIEMPRE comparten exactamente el mismo
 * horario. Sábado y domingo se configuran de forma independiente. Esto es
 * una capa de UI sobre store_cutoffs: al persistir, el grupo "weekdays" se
 * sigue expandiendo a 5 filas (weekday 1..5) para no romper el contrato del
 * backend ni `cutoff_snapshot` de recorridos ya armados.
 */

export type ScheduleGroupKey = "weekdays" | "saturday" | "sunday";

export type GroupedDaySchedule = {
  key: ScheduleGroupKey;
  label: string;
  weekdays: readonly number[];
  enabled: boolean;
  passes: DayPass[];
};

/** Siempre 3 entradas, en este orden: Lun-Vie, Sábado, Domingo. */
export type GroupedWeeklySchedule = GroupedDaySchedule[];

export const SCHEDULE_GROUPS: ReadonlyArray<{
  key: ScheduleGroupKey;
  label: string;
  weekdays: readonly number[];
}> = [
  { key: "weekdays", label: "Lunes a viernes", weekdays: [1, 2, 3, 4, 5] },
  { key: "saturday", label: "Sábado", weekdays: [6] },
  { key: "sunday", label: "Domingo", weekdays: [0] },
];
